type TrainerReviewResultSummaryProps = {
  totalScore: number
  maxScore: number
  qualityPercent: number
  className?: string
}

function formatScore(value: number): string {
  if (!Number.isFinite(value)) return '—'

  return value.toLocaleString('ru-RU', {
    maximumFractionDigits: 1,
  })
}

function formatPercentOneDecimal(value: number): string {
  if (!Number.isFinite(value)) return '—'

  return `${value.toLocaleString('ru-RU', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })}%`
}

function getQualityPercentTextTone(qualityPercent: number): string {
  if (!Number.isFinite(qualityPercent)) return 'text-slate-900'
  return qualityPercent >= 50 ? 'text-emerald-700' : 'text-rose-700'
}

/**
 * Единый итоговый блок для внутреннего и партнёрского отчёта отсмотра.
 *
 * Заголовок следует общей системе мета-карточек: серый label слева.
 * Процент — главный результат и единственный цветовой акцент; баллы —
 * вторичная расшифровка тёмным текстом. На широком экране геометрия
 * карточки задаётся страницей: от строки «Педагог / Дата» до низа
 * «Направления».
 */
export function TrainerReviewResultSummary({
  totalScore,
  maxScore,
  qualityPercent,
  className = '',
}: TrainerReviewResultSummaryProps) {
  const qualityTextTone = getQualityPercentTextTone(qualityPercent)

  return (
    <div
      className={`report-result-summary-card flex min-w-0 flex-col rounded-[20px] border border-slate-300/90 bg-slate-100/80 px-4 py-3.5 shadow-[0_2px_10px_rgba(15,23,42,0.045)] ${className}`}
    >
      <div className="report-result-summary-label text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Итог</div>

      <div className="report-result-summary-values flex min-h-[92px] flex-1 min-w-0 flex-col items-center justify-center text-center lg:min-h-0">
        <div
          className={`report-result-summary-percent max-w-full whitespace-nowrap text-[clamp(1.7rem,1.95vw,1.9rem)] font-bold leading-none tabular-nums tracking-[-0.03em] ${qualityTextTone}`}
        >
          {formatPercentOneDecimal(qualityPercent)}
        </div>
        <div className="report-result-summary-score mt-2.5 max-w-full text-[13px] font-semibold leading-5 tabular-nums text-slate-900">
          {formatScore(totalScore)} из {formatScore(maxScore)} баллов
        </div>
      </div>
    </div>
  )
}
